module.exports = __webpack_public_path__ + "static/MuseoSans-100-60a67f4749a470e85bd6e7fed3785a9c.woff";